<template lang="html">
  <div id="subprojectpage" >
    <section class="container oversized-container">
      <div class="row">
        <div class="col-md-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">{{ $t("shared.titles.home") }}</router-link></li>
              <li class="breadcrumb-item"><router-link to="/productos">{{ $t("shared.titles.products") }}</router-link></li>
              <li class="breadcrumb-item active" aria-current="page" >{{ $t("shared.titles.list") }}</li>
            </ol>
          </nav>
        </div>
      </div>

      <div class="row" >
        <div v-for="project in products" class="col-md-6 col-xl-4 col-subproject">
          <router-link class="project-link" :to="'/detalle/producto/'+project.id">
            <img class="placed-backg img-fluid" src="public/images/shared/article.png" v-bind:style="{ backgroundImage: 'url('+project.image+')' }">

            <div class="box">
              <div class="inside">
                <h5>{{ project.title }}</h5>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      products:[
        /*{ id: 1, image: 'public/images/pages/products/product-1.jpg', name: 'Ventanas oscilantes', },
        { id: 2, image: 'public/images/pages/products/product-2.jpg', name: 'Ventanas y puertas oscilobatientes', },
        { id: 3, image: 'public/images/pages/products/product-3.jpg', name: 'Ventanas y puertas practicables', },
        { id: 3, image: 'public/images/pages/products/product-4.jpg', name: 'Ventanas proyectantes', },
        { id: 4, image: 'public/images/pages/products/product-5.jpg', name: 'Ventanas y puertas corredizas', },
        { id: 5, image: 'public/images/pages/products/product-6.jpg', name: 'Ventanas con motor', },
        { id: 6, image: 'public/images/pages/products/product-7.jpg', name: 'Ventanas fijas', },
        { id: 7, image: 'public/images/pages/products/product-8.jpg', name: 'Puertas plegadizas', },
        { id: 8, image: 'public/images/pages/products/product-5.jpg', name: 'Puertas osciloparalelas', },*/
      ],
    }
  },

  methods: {
    getProducts:function(id){
      axios.get(tools.url('/productsFront/'+this.id)).then(
        ({data}) =>{
          this.products=data;
        }
      );
    },
  },

  mounted() {
    this.id = this.$route.params.id;
     this.getProducts(this.id);
  },
}
</script>
